import React from 'react';

const Products: React.FC = () => {
  const productCategories = [
    {
      title: 'Security Solutions',
      icon: '🛡️',
      color: 'from-red-500 to-red-600',
      products: [
        {
          name: 'CCTV System',
          description: 'กล้องวงจรปิดทุกประเภท (Dahua, Hikvision, Hiview, TP-Link Vigi)',
          features: ['AI CCTV', 'Face Recognition', 'License Plate', 'Solar Cell CCTV']
        },
        {
          name: 'Smart Home (IoT)',
          description: 'ระบบบ้านอัจฉริยะ (Hiview, TAPO by TP-Link)',
          features: ['ควบคุมผ่านมือถือ/เสียง', 'ระบบกันขโมย', 'ตรวจจับควันไฟ', 'ระบบ SOS']
        },
        {
          name: 'Barrier & Access Control',
          description: 'ไม้กั้นรถอัตโนมัติและระบบควบคุมการเข้าออก',
          features: ['ใช้บัตร, QR Code', 'กล้องทะเบียน', 'Face Recognition', 'Digital Door Lock']
        }
      ]
    },
    {
      title: 'Hotel & Property Management',
      icon: '🏨',
      color: 'from-purple-500 to-purple-600',
      products: [
        {
          name: 'Digital Door Lock',
          description: 'ระบบล็อคประตูดิจิทัล (VingCard, HIP, ZKTeco, Hiview)',
          features: ['Fingerprint/Face Scan', 'Keycard', 'ระบบ HR Integration', 'Hotel Management']
        },
        {
          name: 'Smart Room',
          description: 'ระบบบริหารหอพัก/คอนโด ผ่าน LINE OA',
          features: ['Billing System', 'Communication', 'Maintenance', 'Resident Portal']
        },
        {
          name: 'Smart City',
          description: 'ระบบสื่อสาร-เก็บค่าบริการสาธารณูปโภค',
          features: ['LINE OA Integration', 'Web/Mobile App', 'Payment System', 'Notification']
        }
      ]
    },
    {
      title: 'Energy Solutions',
      icon: '⚡',
      color: 'from-yellow-500 to-yellow-600',
      products: [
        {
          name: 'Solar Cell',
          description: 'ระบบพลังงานแสงอาทิตย์คุณภาพสูง',
          features: ['อุปกรณ์คุณภาพสูง', 'ทีมงานติดตั้งมืออาชีพ', 'ลดค่าใช้จ่ายพลังงาน', 'รับประกันคุณภาพ']
        }
      ]
    },
    {
      title: 'Network & IT Solutions',
      icon: '🌐',
      color: 'from-blue-500 to-blue-600',
      products: [
        {
          name: 'Network Infrastructure',
          description: 'ออกแบบ/ติดตั้งระบบเครือข่าย (Cisco, Aruba, TP-Link, Zyxel)',
          features: ['Fiber Optic', 'LAN Cabling', 'WiFi Solutions', 'Server Room']
        },
        {
          name: 'Security & Firewall',
          description: 'ระบบรักษาความปลอดภัยเครือข่าย (Fortinet, Sangfor, Sophos)',
          features: ['Firewall', 'Antivirus', 'Network Security', 'Threat Protection']
        }
      ]
    },
    {
      title: 'Software Development',
      icon: '💻',
      color: 'from-green-500 to-green-600',
      products: [
        {
          name: 'Web & Mobile Apps',
          description: 'พัฒนาเว็บไซต์ แอปพลิเคชัน และระบบงาน',
          features: ['Website Design', 'Mobile App', 'Workflow App', 'Asset Management']
        },
        {
          name: 'ERP Integration',
          description: 'ระบบ ERP และการจัดการองค์กร (Odoo, SAP, Oracle)',
          features: ['ERP Integration', 'Workflow Management', 'Data Analytics', 'Custom Development']
        }
      ]
    },
    {
      title: 'IPTV & Digital Signage',
      icon: '📺',
      color: 'from-indigo-500 to-indigo-600',
      products: [
        {
          name: 'IPTV System',
          description: 'ระบบ IPTV สำหรับโรงพยาบาล, โรงแรม, ศูนย์การค้า',
          features: ['Multi-room IPTV', 'Content Management', 'Live Streaming', 'Interactive Features']
        },
        {
          name: 'Digital Signage',
          description: 'ระบบป้ายดิจิทัลและแสดงผลข้อมูล',
          features: ['Dynamic Content', 'Remote Management', 'Multi-zone Display', 'Analytics']
        }
      ]
    }
  ];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-napa-blue-800 mb-4">
            ผลิตภัณฑ์และโซลูชัน
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ผลิตภัณฑ์และบริการครบวงจรที่ตอบสนองความต้องการทุกอุตสาหกรรม
          </p>
        </div>

        {/* Product Categories */}
        <div className="space-y-16">
          {productCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="bg-gray-50 rounded-2xl p-8">
              <div className="flex items-center mb-8">
                <div className={`w-16 h-16 bg-gradient-to-r ${category.color} rounded-xl flex items-center justify-center text-2xl mr-4`}>
                  {category.icon}
                </div>
                <h3 className="text-2xl font-bold text-napa-blue-800">
                  {category.title}
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.products.map((product, productIndex) => (
                  <div
                    key={productIndex}
                    className="bg-white rounded-xl p-6 shadow-md card-hover border border-gray-200"
                  >
                    <h4 className="text-lg font-bold text-napa-blue-800 mb-3">
                      {product.name}
                    </h4>
                    <p className="text-gray-600 mb-4 text-sm">
                      {product.description}
                    </p>
                    <ul className="space-y-1">
                      {product.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-center text-xs text-gray-600">
                          <svg className="w-3 h-3 text-napa-blue-500 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Featured Projects */}
        <div className="mt-16 bg-gradient-to-r from-napa-blue-600 to-napa-blue-800 rounded-2xl p-8 text-white">
          <h3 className="text-2xl font-bold mb-6 text-center">
            โครงการเด่น
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">60+</div>
              <div className="text-blue-200 text-sm">Masterpiece Hospital</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">800+</div>
              <div className="text-blue-200 text-sm">Wyndham Jomtien Pattaya</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">100%</div>
              <div className="text-blue-200 text-sm">ความพึงพอใจลูกค้า</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">24/7</div>
              <div className="text-blue-200 text-sm">บริการสนับสนุน</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
